<template>
  <v-container>
    <v-form v-if="!logged" ref="loginForm" v-model="valid">
      <p class="headline">Login</p>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="password"
            type="password"
            label="Heslo"
            :rules="requiredRules"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-btn @click="login()">Prihlásiť</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <p v-if="logged" class="title">
      Používateľ systému
      <span class="headline font-weight-black">{{ cname }}</span> je prihlásený.
    </p>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: "",
    password: "",
    emailRules: [
      v => !!v || "E-mail musí byť zadaný",
      v => /.+@.+/.test(v) || "E-mail nemá správny formát"
    ],
    requiredRules: [v => !!v || "Položka musí byť zadaná"],
    valid: true
  }),

  computed: {
    cname: function() {
      return this.$store.state.name
    },

    logged: function() {
      return this.$store.state.logged
    },

    version: function() {
      return this.$store.state.version
    },

    stats: function() {
      return this.$store.state.stats
    }
  },

  methods: {
    login: async function() {
      console.log("login")
      console.log(this.$data)
      if (this.$refs.loginForm.validate()) {
        try {
          let response = await this.$axios.post("/api/login", {
            email: this.email,
            password: this.password
          })
          console.log("response:", response)
          if (response.status === 200) {
            localStorage.email = this.email
            localStorage.token = response.data.token
            this.$axios.defaults.headers.common["token"] = localStorage.token
            this.$store.commit("login", response.data.user)
            this.$store.commit(
              "message",
              "Prihlásenie do aplikácie bolo úspešné"
            )
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    }
  },

  mounted: async function() {
    console.log("login mounted")
    await this.$store.dispatch("fetchme", this.$axios)
  }
}
</script>
